var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgNotCheckCircle = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 48,
  viewBox: "0 0 48 48",
  fill: "none",
  ref: svgRef
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 23.5,
  stroke: "#D83535"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M30.9844 18.4219L25.4062 24L30.9844 29.5781L29.5781 30.9844L24 25.4062L18.4219 30.9844L17.0156 29.5781L22.5938 24L17.0156 18.4219L18.4219 17.0156L24 22.5938L29.5781 17.0156L30.9844 18.4219Z",
  fill: "#D83535"
})));

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNotCheckCircle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/not-check-circle.37a11b93.svg";
export { ForwardRef as ReactComponent };